import { AppLogo } from '@/components/common/AppLogo';
import { formatDisplayDate } from '@/utils/date';
import type { PcmpMisStatusReport } from '../../types/pcmpMisStatusReport.types';
import { PcmpMisStatusReportTable } from './PcmpMisStatusReportTable';

/** The MIS Status report as printed: heading, what it covers, then the table. */
export function PcmpMisStatusReportSheet({ report }: { report: PcmpMisStatusReport }) {
  return (
    <div className="flex flex-col gap-2 text-neutral-900">
      <div className="flex items-center justify-between gap-4">
        <AppLogo className="size-9" />
        <div className="text-right">
          <h1 className="text-base font-bold">MIS Status Update Report</h1>
          <p className="text-xs text-neutral-600">
            {report.projectLabel} · {report.periodLabel}
          </p>
          <p className="text-xs text-neutral-600">As of {formatDisplayDate(report.reportDate)}</p>
        </div>
      </div>
      <p className="text-xs">
        Verified {report.verifiedTotal} · Not verified {report.notVerifiedTotal} · Total updates{' '}
        {report.totalUpdates} · {report.memberCount} team members
      </p>
      <PcmpMisStatusReportTable report={report} />
    </div>
  );
}
